import * as React from "react"

export type SidebarContextValue = {
  state: "expanded" | "collapsed"
  open: boolean
  setOpen: (open: boolean) => void
  openMobile: boolean
  setOpenMobile: (open: boolean) => void
  isMobile: boolean
  toggleSidebar: () => void
  /** Current expanded sidebar width in pixels (drag-resizable, persisted). */
  width: number
  /** Commit a new sidebar width (clamped + persisted to a cookie). */
  setWidth: (px: number) => void
}

export const SidebarContext = React.createContext<SidebarContextValue | null>(null)

export const useSidebar = () => {
  const context = React.useContext(SidebarContext)
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider.")
  }

  return context
}
